import styled from 'styled-components'

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  gap: 20px;
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
`

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  text-align: center;
  margin: 0;
`

export const LargeText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  text-align: center;
  margin: 0;
  line-height: 24px;
`

export const ContainerButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 20px;
`

export const Action = styled.button`
  background-color: transparent;
  border: none;
  color: #2d749c;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 20px;

  &:hover {
    opacity: 0.8;
  }
`

